import React, { useEffect, useState } from "react";
import "./Universite.scss";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import PropTypes from "prop-types";
import { Accordion, AccordionTab } from "primereact/accordion";
import { connect } from "react-redux";
import HeaderUserLogin from "Components/Header/HeaderTop/HeaderUserLogin/HeaderUserLogin";
import Modal from "Components/Modal/Modal";
import CompteUniversite from "Components/Modal/ModalCreationCompte/CompteUniversite/CompteUniversite";
import { HTMLParseOptions } from "Services/htmlParseOptions";
import parse from "html-react-parser";
import { sanitizeHtml } from "Services/functions";
import { authenticateUser } from "Services/auth";

const Universite = (props) => {
  const [loginVisible, setLoginVisible] = useState(false);
  const [creationCompteVisible, setCreationCompteVisible] = useState(false);
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];
  const [presentationUniv, setPresentationUniv] = useState("");

  useEffect(() => {
    setPresentationUniv(
      parse(sanitizeHtml(props.univ.defaultPresentation), HTMLParseOptions)
    );
  }, [props.univ]);

  const displayRegister = () => setCreationCompteVisible(true);
  const displayLogin = () => setLoginVisible(true);

  return (
    <>
      <div className="universite desktop">
        <img
          src={API_LINK + props.univ.imageTransparentAndColorUrl}
          alt={props.univ.imageAlt}
          title={props.univ.imageTitle}
        />
        <div className="universite__container">
          {presentationUniv}
          <div className="universite__container__buttons">
            <BtnBleu
              btnTexte="Se connecter"
              btnAction={(e) => {
                e.preventDefault();
                authenticateUser(props.univ, true, displayLogin);
              }}
            />
            <BtnBlanc
              btnTexte="Créer un compte"
              btnAction={(e) => {
                e.preventDefault();
                authenticateUser(props.univ, true, displayRegister);
              }}
            />
          </div>
        </div>
      </div>
      <div className="universite mobile">
        <Accordion activeIndex={props.actif}>
          <AccordionTab
            header={
              <>
                <img
                  src={API_LINK + props.univ.imageTransparentAndColorUrl}
                  alt={props.univ.imageAlt}
                  title={props.univ.imageTitle}
                />
              </>
            }
          >
            <div className="universite__container">
              <p>{presentationUniv}</p>
              <div className="universite__container__buttons">
                <BtnBleu
                  btnTexte="Se connecter"
                  btnAction={(e) => {
                    e.preventDefault();
                    setLoginVisible(true);
                  }}
                />
                <BtnBlanc
                  btnTexte="Créer un compte"
                  btnAction={(e) => {
                    e.preventDefault();
                    displayRegister;
                  }}
                />
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
      {loginVisible && (
        <HeaderUserLogin
          key={loginVisible}
          loginVisible={loginVisible}
          setLoginVisible={setLoginVisible}
          universityId={props.univ.id}
        />
      )}
      {creationCompteVisible && (
        <Modal
          visible={creationCompteVisible}
          setVisible={setCreationCompteVisible}
          header="Création de compte"
        >
          <div className="description">
            <CompteUniversite
              setVisibleUniv={setCreationCompteVisible}
            ></CompteUniversite>
          </div>
        </Modal>
      )}
    </>
  );
};

Universite.propTypes = {
  univ: PropTypes.object,
  actif: PropTypes.number,
  admin: PropTypes.object,
};

const mapStateToProps = (state) => ({
  admin: state.admin,
});

export default connect(mapStateToProps)(Universite);
